module.exports = __webpack_public_path__ + "src/images/html5-logo.8377242b0d67bcedf9af89d6c0facc92.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/html5-logo.png
// module id = 94
// module chunks = 0